import { makeStyles } from "@material-ui/core";
import { Colors } from "../../styles/Colors";
import dayjs from "../../services/customDayJs";

export const useStyles = makeStyles(() => ({
    accountControlPanelContainer: {
        display: 'flex',
        flexDirection: 'row',
        background: Colors.White,
    },
    wrapUpTimeContainer: {
        marginRight: 24,
        padding: '19px 27px',
        width: 'fit-content',
        height: 'fit-content',
        display: 'flex',
        flexDirection: 'row',
        border: '1px solid rgba(221, 225, 231, 1)',
        borderRadius: 8,
        alignItems: 'center',
    },
    didNumberContainer: {
        marginRight: 36,
        padding: 8,
        paddingTop: 12,
        width: 'fit-content',
        height: 'fit-content',
        display: 'flex',
        flexDirection: 'column'
    },
    statusContainer: {
        height: 'fit-content',
        width: 246,
    },
    wrapUpLabel: {
        fontWeight: 700,
        fontSize: 14,
        lineHeight: '20px',
        verticalAlign: 'middle',
        color: Colors.Text,
        marginRight: 16,
        opacity: 0.6,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    timeLabel: {
        fontWeight: 700,
        fontSize: 16,
        lineHeight: '20px',
        color: Colors.Text,
        marginRight: 16,
    },
    stopTimerButtonContainer: {
        marginTop: -5.5,
        marginRight: 16,
    },
    stopTimerButton: {
        color: Colors.PlaceHolder,
        padding: 0,

        '& svg': {
            color: `${Colors.PlaceHolder}`,
        },
        
        '&:hover': {
            background: `${Colors.Gray2}!important`,
            borderRadius: 6
        },
    },
    addTimeButtonContainer: {
        marginTop: -5.5,
    },
    addTimeButton: {
        color: 'rgba(76, 134, 183, 1)',
        padding: 0,

        '& svg': {
            color: 'rgba(76, 134, 183, 1)',
        },
        
        '&:hover': {
            background: `${Colors.Gray2}!important`,
            borderRadius: 6
        },
    },
    didNumberText: {
        fontWeight: 400,
        fontSize: 12,
        lineHeight: '16px',
        color: 'rgba(0, 0, 0, 0.38)'
    },
    didNumberDetailsContainer: {
        display: 'flex',
        width: 'fit-content',
        flexDirection: 'row',
        marginRight: 12,
    },
    didNumberValueLabel: {
        fontWeight: 700,
        fontSize: 14,
        lineHeight: '20px',
        color: Colors.Text + ' !important',
        opacity: 0.6,
    },
    didNumberBadge: {
        width: 20,
        height: 20,
        background: 'rgba(236, 236, 236, 1)',
        borderRadius: 10,
        fontWeight: 500,
        fontSize: 14,
        textAlign: 'center',
        color: 'rgba(0, 0, 0, 0.6)',
        marginLeft: 10,
        lineHeight: '20px',
    },
    barLoaderContainer: {
        justifyItems: 'right',
        height: 62
    },
    barLoader: {
        height: 16,
        width: 160,
        borderRadius: 6,
        marginBottom: 2,
        marginTop: 2
    },
    barLoader2: {
        width: 120,
    }
}));

export const formatDuration = (seconds: number, defaultValue = '0:00') => {
    if (!seconds) {
        return defaultValue;
    }
    const duration = dayjs.duration(seconds, 'seconds');
    let format = 'HH:mm:ss';

    if (seconds < 60) {
        format = '00:ss';
    } else if (seconds >= 60 && seconds < 3600) {
        format = 'mm:ss';
    }

    return duration.format(format);
};